module.exports = __webpack_public_path__ + "static/media/material-file.a66f6839.svg";